import React, { useState } from 'react';
function TabContainer() {
  const [state, setState] = useState({
      tabs: [
        'Neo Series',
        'Luxe',
        'Luxelet',
        'Toilet Seat',
        'Water Filter',
        'Footstool',
      ],
      selected: 'Neo Series',
    }),
    handleClick = (tab) => {setState({...state,selected:tab})};
    //console.log('tab' +)
  return (
    <ul className="tabContainer">
      {state.tabs.map(tab => (
        <li
          onClick={() => handleClick(tab)}
          className={'tab' +  (tab === state.selected ? ' active' : '')}
          key={tab}
        >
          {tab}
        </li>
      ))}
    </ul>
  );
}
export default TabContainer;



// WEBPACK FOOTER //
// ./src/TabContainer.jsx